export function getPageNumbers(
    currentPage: number,
    totalPages: number,
    maxPagesToShow = 7,
): (number | "...")[] {
    const safeTotalPages = Math.max(0, Math.floor(totalPages));
    const safeCurrentPage = Math.min(
        Math.max(1, Math.floor(currentPage)),
        Math.max(1, safeTotalPages),
    );

    if (safeTotalPages <= maxPagesToShow) {
        return Array.from({ length: safeTotalPages }, (_, index) => index + 1);
    }

    const pages: (number | "...")[] = [1];

    if (safeCurrentPage <= 2) {
        pages.push(2, 3, "...", safeTotalPages);
    } else if (safeCurrentPage === 3) {
        pages.push(2, 3, 4, "...", safeTotalPages);
    } else if (safeCurrentPage >= safeTotalPages - 1) {
        pages.push("...", safeTotalPages - 2, safeTotalPages - 1, safeTotalPages);
    } else if (safeCurrentPage === safeTotalPages - 2) {
        pages.push(
            "...",
            safeTotalPages - 3,
            safeTotalPages - 2,
            safeTotalPages - 1,
            safeTotalPages,
        );
    } else {
        pages.push(
            "...",
            safeCurrentPage - 1,
            safeCurrentPage,
            safeCurrentPage + 1,
            "...",
            safeTotalPages,
        );
    }

    return pages;
}
